import React from 'react'
import mediaippieGroup from '../images/media-left-hippie-group.png';
import BlogsSlider from './Sliders/BlogsSlider';


function NewsMedia() {
  return (
    <section className="news-media">
      <div className="row-one">
        <h3>News & Media</h3>
      </div>
      <div className="row-two">
        <div className="static-block">
          <img src={mediaippieGroup} alt="hippies" />
          <p>INSPIRE, PARTICIPATE AND CREATE YOUR FELLOW HIPPIES</p>
          <a href="/" className='media-link'>VIEW HIPPIE MEDIA</a>
        </div>

        <div className="news-block">
            <BlogsSlider />
        </div>
      </div>
    </section>
  );
}

export default NewsMedia